export class InitialWorkflowResult {
  public isError: boolean;
  public errorDescription: string;
  public selectedWorkflow: string;
}
